import {
  Box,
  Column,
  Columns,
  Heading,
  IconFilter,
  Inline,
  Stack,
  Text,
} from 'braid-design-system';
import { observer } from 'mobx-react';
import { type FC, type ReactNode, useEffect, useState } from 'react';
import { FilterSideBarContent } from './FilterSideBarContent';
import { FilterClearButton } from './FilterClearButton';
import { useStores } from 'src/utils/hooks/useStores';
import translations from './.vocab';
import { useTranslations } from '@vocab/react';

export const FilterSideBar: FC = observer(() => {
  const [isReadyOnClient, setIsReadyOnClient] = useState(false);
  const {
    jobApplicationStore: { filtersStore },
  } = useStores();
  useEffect(() => {
    setIsReadyOnClient(true);
  }, []);

  if (!isReadyOnClient) {
    return <Layout clearButton={null} content={<FilterSideBarContent />} />;
  }

  return (
    <Layout
      clearButton={
        filtersStore?.hasSelectedFilter ? <FilterClearButton /> : null
      }
      content={<FilterSideBarContent />}
    />
  );
});

const Layout: FC<{
  clearButton: ReactNode;
  content: ReactNode;
}> = ({ clearButton, content }) => {
  const { t } = useTranslations(translations);
  return (
    <Box background="surface" padding="gutter" paddingTop="large">
      <Stack space="large">
        <Columns space="small">
          <Column>
            <Heading level="3">
              <Inline space="xsmall" alignY="center">
                <IconFilter />
                <Text data={{ intercomid: 'byFilters' }}>{t('Filters')}</Text>
              </Inline>
            </Heading>
          </Column>
          <Column width="content">{clearButton}</Column>
        </Columns>
        <>{content}</>
      </Stack>
    </Box>
  );
};
